import { DtoCobranza } from './../dominio/DtoCobranza';
import { FiltroCoCobranza } from './../dominio/FiltroCoCobranza';
import { CoCobranza } from './../dominio/CoCobranza';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { DtoCoDocumentoCobrar } from '../../codocumento/dominio/DtoCoDocumentoCobrar';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoCobranzaServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/cocobranza/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerPorIdCompleto(unidad: string, nrocobranza: number): Promise<CoCobranza> {

        const params = new HttpParams().set('unidadreplicacion', unidad)
                                       .set('cobranzanumero', JSON.stringify(nrocobranza));

        return this.http.get(`${this.url}obtenerPorIdCompleto`, { params ,headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCobranza;
            })
            .catch(error => null);
    }

    public listarCobranzaPaginacion(filtro: FiltroCoCobranza): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarCobranzaPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    } 

    public listarDocumentosCobranza(filtro: FiltroCoCobranza): Promise<DtoCoDocumentoCobrar[]> {
        return this.http.post(`${this.url}listarDocumentosCobranza`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar[];
            })
            .catch(error => []);
    }
}

